import { format, parseISO } from 'date-fns';

export const dateFormat = {
    data() {
        return {
            MX_dateFormat: this.$store.getters.dateFormat,
        }
    },
    methods: {
        dateFormat (date) {
            if (date) {
                if (typeof date === 'string') {
                    return format(parseISO(date), this.MX_dateFormat)
                }
                return format(date, this.MX_dateFormat);
            }

        }
    }
};

export const requestDateFormat = {
    data() {
        return {
            MX_requestFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSxxx',
        }
    },
    methods: {
        requestDateFormat (date) {
            if (date) {
                return format(new Date(this.dateFormat(date)), this.MX_requestFormat);
            }
        }
    }
};

export const requestDateFormatUTC = {
    data() {
        return {
            MX_requestFormatUTC: 'yyyy-MM-dd',
        }
    },
    methods: {
        requestDateFormatUTC (date) {
            if (date) {
                if (typeof date === 'string') {
                    return format(parseISO(date), this.MX_requestFormatUTC)
                }
                return format(date, this.MX_requestFormatUTC);
            }
        }
    }
};

export const requestDateFormatLocalDate = {
    data() {
        return {
            MX_requestFormatLocalDate: 'yyyy-MM-dd',
        }
    },
    methods: {
        requestDateFormatLocalDate (date) {
            if (date) {
                return format(new Date(this.dateFormat(date)), this.MX_requestFormatLocalDate);
            }
        }
    }
};

export const zoneIdDateFormat = {
    data() {
        return {
            MX_requestFormatZoneId: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSxxx',
        }
    },
    methods: {
        zoneIdDateFormat (date) {
            if (date) {
                if (typeof date === 'string') {
                    return format(parseISO(date), this.MX_requestFormatZoneId).slice(-6)
                }
                return format(date, this.MX_requestFormatZoneId).slice(-6);
            }
        }
    }
};

export const requestDateFormatUTCTime = {
    data() {
        return {
            MX_requestFormatZoneId: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSxxx',
        }
    },
    methods: {
        requestDateFormatUTCTime (date) {
            if (date) {
                let dateTimeUTC = '';
                if (typeof date === 'string') {
                    dateTimeUTC = format(parseISO(date), this.MX_requestFormatZoneId)
                }
                dateTimeUTC = format(date, this.MX_requestFormatZoneId);

                dateTimeUTC = dateTimeUTC.substring(0, dateTimeUTC.length - 10);

                return dateTimeUTC;
            }
        }
    }
};

export const requestDateFormatEndOfDay = {
    data() {
        return {
            MX_requestFormatEndOfDay: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSxxx',
        }
    },
    methods: {
        requestDateFormatEndOfDay (date) {
            if (date) {
                return format(new Date(date).setHours(23, 59, 59, 999), this.MX_requestFormatEndOfDay);
            }
        }
    }
};

export const requestDateFormatCurrentTime = {
    data() {
        return {
            MX_requestFormatCurrentTime: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSxxx',
        }
    },
    methods: {
        requestDateFormatCurrentTime (date) {
            if (date) {
                return format(new Date(date), this.MX_requestFormatCurrentTime);
            }
        }
    }
};
